export class GoToFundedTabEvent {}
